const getSafeString = value => {
    if (value === null || value === undefined) {
        return ""
    }
    return String(value)
}

export const parseModuloCassaStatisticNumber = value => {
    if (value === null || value === undefined || value === "") {
        return 0
    }

    const numericValue = typeof value === "number" ? value : parseFloat(String(value).replace(",", "."))
    return Number.isNaN(numericValue) ? 0 : numericValue
}

const normalizePaymentMethods = paymentMethods => {
    return (paymentMethods || []).map(paymentMethod => {
        return {
            tipo: getSafeString(paymentMethod && paymentMethod.tipo),
            descrizione: paymentMethod && paymentMethod.descrizione ? paymentMethod.descrizione : "Metodo non specificato",
            importo: parseModuloCassaStatisticNumber(paymentMethod && paymentMethod.importo)
        }
    })
}

const getIvaSortValue = code => {
    const parsedCode = parseFloat(code)
    return Number.isNaN(parsedCode) ? Number.MAX_SAFE_INTEGER : parsedCode
}

const normalizeIva = iva => {
    const normalizedRows = []
    const safeIva = iva || {}

    Object.keys(safeIva).forEach(code => {
        if (code === "imponibile" || code === "imposta" || code === "stima_iva_da_versare") {
            return
        }

        const value = safeIva[code]
        if (value && typeof value === "object" && !Array.isArray(value)) {
            normalizedRows.push({
                code: code,
                imponibile: parseModuloCassaStatisticNumber(value.imponibile),
                imposta: parseModuloCassaStatisticNumber(value.imposta),
                hasImposta: value.imposta !== null && value.imposta !== undefined
            })
            return
        }

        normalizedRows.push({
            code: code,
            imponibile: parseModuloCassaStatisticNumber(value),
            imposta: 0,
            hasImposta: false
        })
    })

    normalizedRows.sort((firstRow, secondRow) => {
        const firstSortValue = getIvaSortValue(firstRow.code)
        const secondSortValue = getIvaSortValue(secondRow.code)

        if (firstSortValue !== secondSortValue) {
            return firstSortValue - secondSortValue
        }

        return firstRow.code.localeCompare(secondRow.code)
    })

    return {
        imponibile: safeIva.imponibile !== undefined ?
            parseModuloCassaStatisticNumber(safeIva.imponibile) :
            normalizedRows.reduce((total, row) => total + row.imponibile, 0),
        imposta: safeIva.imposta !== undefined ?
            parseModuloCassaStatisticNumber(safeIva.imposta) :
            parseModuloCassaStatisticNumber(safeIva.stima_iva_da_versare),
        rows: normalizedRows
    }
}

const normalizeStatisticsSection = section => {
    const safeSection = section || {}

    return {
        number: parseModuloCassaStatisticNumber(safeSection.number !== undefined ? safeSection.number : safeSection.inviati),
        total: parseModuloCassaStatisticNumber(safeSection.total !== undefined ? safeSection.total : safeSection.totale),
        paymentMethods: normalizePaymentMethods(safeSection.payment_methods || safeSection.metodi_pagamento),
        iva: normalizeIva(safeSection.iva)
    }
}

export const normalizeModuloCassaStatistics = statistics => {
    const safeStatistics = statistics || {}
    const sentSection = normalizeStatisticsSection(
        safeStatistics.inviata_ae || {
            number: safeStatistics.inviati,
            total: safeStatistics.totale,
            payment_methods: safeStatistics.payment_methods || safeStatistics.metodi_pagamento,
            iva: safeStatistics.iva
        }
    )
    const createdSection = normalizeStatisticsSection(
        safeStatistics.creata || {
            number: safeStatistics.creati || safeStatistics.salvati || 0,
            total: safeStatistics.creata_totale || 0,
            payment_methods: safeStatistics.creata_payment_methods || [],
            iva: safeStatistics.creata_iva || {}
        }
    )
    const cancelledSection = normalizeStatisticsSection(
        safeStatistics.annullata || {
            number: safeStatistics.annullati || 0,
            total: safeStatistics.annullata_totale || 0,
            payment_methods: safeStatistics.annullata_payment_methods || [],
            iva: safeStatistics.annullata_iva || {}
        }
    )

    const paymentMethods = normalizePaymentMethods(
        safeStatistics.payment_methods ||
        safeStatistics.metodi_pagamento ||
        sentSection.paymentMethods
    )

    const queueSent = parseModuloCassaStatisticNumber(
        safeStatistics.send_queue && safeStatistics.send_queue.sent !== undefined ?
            safeStatistics.send_queue.sent :
            safeStatistics.inviati_da_sempre
    )
    const queueToSend = parseModuloCassaStatisticNumber(
        safeStatistics.send_queue && safeStatistics.send_queue.to_send !== undefined ?
            safeStatistics.send_queue.to_send :
            safeStatistics.salvati_da_sempre
    )
    const queueTrackedTotal = queueSent + queueToSend

    return {
        number: safeStatistics.number !== undefined ?
            parseModuloCassaStatisticNumber(safeStatistics.number) :
            sentSection.number + createdSection.number + cancelledSection.number,
        total: safeStatistics.total !== undefined ?
            parseModuloCassaStatisticNumber(safeStatistics.total) :
            sentSection.total + createdSection.total,
        returns: parseModuloCassaStatisticNumber(safeStatistics.resi),
        sent: sentSection,
        created: createdSection,
        cancelled: cancelledSection,
        paymentMethods: paymentMethods,
        queue: {
            startDate: safeStatistics.send_queue ? safeStatistics.send_queue.start_date : null,
            sent: queueSent,
            toSend: queueToSend,
            trackedTotal: queueTrackedTotal,
            completionPercentage: queueTrackedTotal > 0 ? (queueSent * 100) / queueTrackedTotal : (queueToSend > 0 ? 0 : 100)
        },
        goal: {
            difference: safeStatistics.goal_difference === null || safeStatistics.goal_difference === undefined ? null : parseModuloCassaStatisticNumber(safeStatistics.goal_difference),
            period: safeStatistics.goal_period || null,
            target: safeStatistics.goal_target === null || safeStatistics.goal_target === undefined ? null : parseModuloCassaStatisticNumber(safeStatistics.goal_target),
            currentTotal: safeStatistics.goal_current_total === null || safeStatistics.goal_current_total === undefined ? null : parseModuloCassaStatisticNumber(safeStatistics.goal_current_total)
        }
    }
}
